import { format, getDate, isValid, parseISO } from 'date-fns'

// date-fns utils

const getOrdinalSuffix = (day: number) => {
  if (day >= 11 && day <= 13) return 'th'
  switch (day % 10) {
    case 1:
      return 'st'
    case 2:
      return 'nd'
    case 3:
      return 'rd'
    default:
      return 'th'
  }
}

type ValidDateRoot = string | number | Date

const parseDate = (input: ValidDateRoot) => {
  if (input instanceof Date) return input

  if (typeof input === 'number') return new Date(input)

  // Try ISO 8601 first (most reliable with date-fns)
  const isoDate = parseISO(input)

  if (isValid(isoDate)) return isoDate

  // Fall back to native Date parsing for other string formats
  const fallback = new Date(input)

  if (isValid(fallback)) return fallback

  //Fallback to empty string on fail
  return ''
}

const formatDateWithOrdinal = (input: ValidDateRoot): string => {
  const date = parseDate(input)

  if (!date) return ''

  const day = getDate(date)
  const suffix = getOrdinalSuffix(day)

  return format(date, `MMM d'${suffix}', yyyy`)
}

function getSecondsFromDateString(dateString: string): number {
  const date = new Date(dateString)
  if (isNaN(date.getTime())) {
    throw new Error('Invalid date string')
  }
  return Math.floor(date.getTime() / 1000)
}

export { formatDateWithOrdinal, getSecondsFromDateString, parseDate }
